const initialize =  function(){
        global._WORKING_ENV_='production';
        console.log(`set the value to ${global._WORKING_ENV_} for process.env._WORKING_ENV_ `);
    }
module.exports= {initialize}